<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Выберите склад</label>
              <select v-model="selectedStore" class="form-control">
                <optgroup label="---">
                  <option value="3">Москва</option>
                  <option value="10">СПБ</option>
                </optgroup>
                <optgroup label="---">
                  <option v-for="s in getSortedStores().filter((s) => ![3,10,30].includes(s.id))" :value="s.id">{{
                      s.title
                    }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-group mb-0">
              <label>Выберите препарат</label>
              <DrugSearchNew
                ref="searchDrug"
                :searchOptions="{inStores: true, prices: true}"
                :onSelect="(d) => selectDrug(d)"
              />
            </div>
          </div>
          <div class="col-md-12">
            <template v-if="selectedDrugs.length">
              <table class="table mt-0 table-sm table-hover">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Препарат</th>
                  <th>Склад</th>
                  <th>Новое количество</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="d in selectedDrugs">
                  <td>{{ d.id }}</td>
                  <td>{{ d.title }}</td>
                  <td>{{ getStoreQty(d) }}</td>
                  <td>
                    <input type="number" v-model="newStoreQty[d.id]" class="form-control">
                  </td>
                  <td>
                    <button @click="removeDrug(d.id)" class="btn btn-outline-danger"><i class="icon-fa icon-fa-remove"/>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="mt-1 text-right">
                <LoadingButton
                  title="Поиск вариантов"
                  :loading="loading"
                  type="button"
                  :color="$constants.SUCCESS_COLOR"
                  :onClick="() => searchOrders()"
                  className="btn btn-outline-success"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <pulse-loader :loading="updateLoading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div class="card" v-if="(orders.length || Object.keys(extraOrders).length) && !updateLoading">
      <div class="card-body">
        <table class="table table-hover table-sm mt-0">
          <thead>
          <tr>
            <th>ID</th>
            <th>Препараты</th>
            <th>Фин.</th>
            <th>Изменения</th>
            <th>Н.Фин</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <template v-for="o in orders">
            <CorrectionOrderTr :o="o" :orders-changes="ordersChanges" :update-orders="updateOrders"/>
          </template>
          <template v-for="(orders, divId) in extraOrders">
            <tr>
              <td class="bg-warning" colspan="15"><strong>{{ $AllDivisions[divId].title }}</strong></td>
            </tr>
            <CorrectionOrderTr v-for="o in orders" :key="o.id" :o="o" :orders-changes="ordersChanges"
                               :update-orders="updateOrders"/>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import CorrectionOrderTr from "@/views/stores/components/CorrectionOrderTr.vue";
import order from "@/views/tablet/orders/Order.vue";

export default {
  components: {
    CorrectionOrderTr,
    DrugSearchNew,
    LoadingButton,
  },
  data() {
    return {
      updateLoading: false,
      loading: false,
      selectedStore: 3,
      selectedDrugs: [],
      newStoreQty: {},
      storeChanges: {},
      orders: [],
      extraOrders: {},
      ordersChanges: {},
    }
  },
  computed: {
    order() {
      return order
    },
    $AllStores() {
      return this.$store.getters['platform/stores'];
    }
  },
  methods: {
    async updateOrders(id) {
      this.updateLoading = true;
      const {data} = await api.post('/new/orders/correction', {
        order_id: id,
        store_id: this.selectedStore,
        changes: this.ordersChanges[id]
      })
      if (data.success) {
        this.selectedDrugs = [];
        this.ordersChanges = {};
        this.newStoreQty = {};
        this.extraOrders = {};
        this.orders = [];
        toastr['success']('Заявка обновлена');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.updateLoading = false;
    },
    selectDrug(d) {
      if (d?.id) {
        if (this.selectedDrugs.length >= 2) {
          toastr['warning']('Уже добавлено 2 препарата');
          return;
        }
        if (!this.selectedDrugs.find((drug) => drug.id === d.id)) {
          this.selectedDrugs.push(d);
          this.$refs.searchDrug.drug = null;
        }
      }
    },
    removeDrug(drugId) {
      this.selectedDrugs = this.selectedDrugs.filter((d) => d.id !== drugId);
    },
    getSortedStores() {
      return _.orderBy(this.$AllStores, 'title');
    },
    getStoreQty(drug) {
      if (!this.selectedStore) return 0;
      const store = drug.in_stores.find((s) => s.store_id === +this.selectedStore);
      return store?.qty || 0;
    },
    getOrdersChanges() {
      const arrangedDrugs = this.selectedDrugs.reduce((acc, d) => {
        acc[d.id] = d;
        return acc;
      }, {});
      [...this.orders, ...Object.values(this.extraOrders).reduce((acc, p) => {
        acc = [...acc, ...p]
        return acc;
      }, [])].forEach((o) => {
        const toChange = {...this.storeChanges};
        const details = [];
        o.details.forEach((d) => {
          const changes = {...d};
          if (toChange[d.drug_id]) {
            changes.qty -= toChange[d.drug_id];
            changes.toUpdate = true;
            changes.drug = {id: d.drug.id, title: d.drug.title}
            delete toChange[d.drug_id];
          }
          details.push(changes);
        })
        Object.keys(toChange).forEach((drugId) => {
          if (!toChange[drugId]) return;
          const price = arrangedDrugs[drugId].prices.find((p) => p.site_id === o.site_id && p.qty === 1);
          details.push({
            qty: 0 - toChange[drugId],
            price: price.price,
            toUpdate: true,
            drug: {id: arrangedDrugs[drugId].id, title: arrangedDrugs[drugId].title}
          });
        });
        this.ordersChanges[o.id] = {details: details, orderFinance: {}};
        let drugPrices = 0;
        details.forEach((d) => {
          drugPrices += d.price * d.qty;
        });
        const finance = {
          price: o.price,
          delivery_price: 0,
          discount: 0
        };
        if (drugPrices !== finance.price) {
          if (drugPrices > finance.price) {
            finance.discount = drugPrices - finance.price;
          } else {
            finance.delivery_price = finance.price - drugPrices;
          }
        }
        this.ordersChanges[o.id].orderFinance = finance;
      })
    },
    async searchOrders() {
      if (!this.selectedStore) {
        toastr['warning']('склад не выбран', 'Ошибка');
        return;
      }
      if (this.selectedDrugs.length !== 2) {
        toastr['warning']('выберите препараты', 'Ошибка');
        return;
      }
      this.orders = [];
      this.ordersChanges = {};
      this.storeChanges = {};
      this.selectedDrugs.forEach((d) => {
        let inStore = 0;
        d.in_stores.forEach((s) => {
          if (s.store_id === +this.selectedStore) {
            inStore = +s.qty;
          }
        });
        this.storeChanges[d.id] = this.newStoreQty[d.id] - inStore;
      });
      if (!Object.values(this.storeChanges).length
        || Object.values(this.storeChanges).includes(null)
        || Object.values(this.storeChanges).includes(NaN)
        || Object.values(this.storeChanges).includes('')) {
        toastr['warning']('установите новое значение склада', 'Ошибка');
        return;
      }
      this.loading = true;
      const selectedDrugs = this.selectedDrugs.map((d) => d.id);
      const {data} = await api.post('/stores/correction', {
        action: 'search',
        store_id: this.selectedStore,
        drugs: selectedDrugs,
        storeChanges: this.storeChanges,
      })
      if (data.success) {
        this.orders = data.orders;
        this.extraOrders = data.extraOrders;
        this.getOrdersChanges();
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>
